<bds-layout>
    <router-outlet></router-outlet>
    <rt-sidenav sidenav [isAuthenticated]="isAuthenticated"></rt-sidenav>
</bds-layout>
<!-- <mat-progress-spinner [mode]="'indeterminate'" *ngIf="loading$ | async"></mat-progress-spinner> -->
